### 底部总结显示问题修复与整体美化方案

### 问题分析
底部总结无法正常显示的主要原因是数据传递问题。ShopFooter.vue期望接收categories对象，但App.vue中的数据传递逻辑需要调整。

### 修复方案

#### 1. 修复App.vue数据传递
```vue
<template>
  <div id="app" class="d-flex flex-column min-vh-100">
    <!-- 头部组件 -->
    <ShopHeader :title="title"></ShopHeader>

    <!-- 主体内容 -->
    <main class="flex-grow-1">
      <ShopMain ref="shopMain"></ShopMain>
    </main>

    <!-- 底部组件 -->
    <ShopFooter :categories="categories"></ShopFooter>
    <button @click="isShow = true">显示弹窗</button>
    <!-- 传入visible属性给子组件 -->
    <!-- $event 是Vue提供的 特殊变量 ，用于在模板中访问 原生DOM事件对象 或 自定义事件的参数 。 简单来说 $event就是带过来的参数@close="isShow = $event" -->
    <!-- 使用sync修饰符 做了两件事情
     1:将数据传递给子组件
     2:监听了一个事件 事件名为 update:visible (即属性名)
     所以使用:(v-bind) 加上sync修饰符 可直接实现父组件的父子和子父传递的写法 接下来只需要在子组件使用$emit("update:绑定的属性名",参数)触发事件即可
      -->
    <BaseDialog ref="baseDialog" :visible.sync="isShow"></BaseDialog>
    <BaseEarth></BaseEarth>
  </div>
</template>

<script>
import ShopHeader from './components/ShopHeader.vue'
import ShopMain from './components/ShopMain.vue'
import ShopFooter from './components/ShopFooter.vue'
import BaseDialog from './components/BaseDialog.vue'
import BaseEarth from './components/BaseEarth.vue'
export default {
  name: 'App',
  components: {
    ShopHeader,
    ShopMain,
    ShopFooter,
    BaseDialog,
    BaseEarth
  },
  data() {
    return {
      isShow: false,
      title: '欢迎来到华仔购物总站'
    }
  },
  computed: {
    categories() {
      return this.$refs.shopMain ? this.$refs.shopMain.categories : {};
    }
  },
  mounted() {
    // 添加Bootstrap图标支持
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.0/font/bootstrap-icons.css';
    document.head.appendChild(link);
  }
}
</script>

<style>
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
}

/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 动画效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 响应式图片 */
img {
  max-width: 100%;
  height: auto;
}
</style>